import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

import Settings from "views/Settings";

import ContactUs from "views/ContactUs";
import ShowContact from "views/ContactUs/ShowContact";

import SocialLinks from "views/socialLinks";
import AddSocialLink from "views/socialLinks/AddSocial";
import EditSocialLink from "views/socialLinks/EditSocial";

import Hero from "views/home/hero/index.jsx";
import Services from "views/home/services/index.jsx";
import WhyUs from "views/home/whyUs/index.jsx";
import StartJourney from "views/home/startJourney/index.jsx";
import Terms from "views/terms/index.jsx";
import PrivacyPolicy from "views/privacyPolicy/index.jsx";
import CookiesPolicy from "views/cookiesPolicy/index.jsx";

import Objections from "views/objections";
import ShowObjection from "views/objections/ShowObjection";

import DeveloperRequests from "views/developerRequests";
import ShowDeveloperRequest from "views/developerRequests/ShowDeveloperRequest";
import Faqs from "views/faqs";
import Categories from "views/faqs/categories";
import ObjectionService from "views/howWeWorks/objectionService";
import DeveloperRequestService from "views/howWeWorks/developerRequestService";
import ContactPage from "views/staticPages/Contact";
import FaqsPage from "views/staticPages/Faqs";
import HowWeWorksPage from "views/staticPages/HowWeWorks";
import ObjectionsPage from "views/staticPages/Objections";
import PrivacyPage from "views/staticPages/Privacy";
import TermsPage from "views/staticPages/Terms";
import CookiesPage from "views/staticPages/Cookies";
import DeveloperRequestPage from "views/staticPages/DeveloperRequest";

import MetaSeo from "views/seo";
import AddMetaSeo from "views/seo/Add";
import EditMetaSeo from "views/seo/Edit";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/hero"
                element={
                  <AuthRoute>
                    <Hero />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/services"
                element={
                  <AuthRoute>
                    <Services />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/whyUs"
                element={
                  <AuthRoute>
                    <WhyUs />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/startJourney"
                element={
                  <AuthRoute>
                    <StartJourney />
                  </AuthRoute>
                }
              />

              <Route
                path="/policies/terms"
                element={
                  <AuthRoute>
                    <Terms />
                  </AuthRoute>
                }
              />

              <Route
                path="/policies/privacyPolicy"
                element={
                  <AuthRoute>
                    <PrivacyPolicy />
                  </AuthRoute>
                }
              />

              <Route
                path="/policies/cookiesPolicy"
                element={
                  <AuthRoute>
                    <CookiesPolicy />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/objections"
                element={
                  <AuthRoute>
                    <Objections />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/objections/show/:id"
                element={
                  <AuthRoute>
                    <ShowObjection />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/developerRequests"
                element={
                  <AuthRoute>
                    <DeveloperRequests />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/developerRequests/show/:id"
                element={
                  <AuthRoute>
                    <ShowDeveloperRequest />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />

              <Route
                path="/requests/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />
              {/* faqs */}
              <Route
                path="/faqs/categories"
                element={
                  <AuthRoute>
                    <Categories />
                  </AuthRoute>
                }
              />

              <Route
                path="/faqs/faqsList"
                element={
                  <AuthRoute>
                    <Faqs />
                  </AuthRoute>
                }
              />

              {/* how we works */}
              <Route
                path="/howWeWorks/objectionService"
                element={
                  <AuthRoute>
                    <ObjectionService />
                  </AuthRoute>
                }
              />
              <Route
                path="/howWeWorks/developerRequestService"
                element={
                  <AuthRoute>
                    <DeveloperRequestService />
                  </AuthRoute>
                }
              />

              {/* Static Pages */}
              <Route
                path="/pages/contact"
                element={
                  <AuthRoute>
                    <ContactPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/faqs"
                element={
                  <AuthRoute>
                    <FaqsPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/howWeWorks"
                element={
                  <AuthRoute>
                    <HowWeWorksPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/privacy"
                element={
                  <AuthRoute>
                    <PrivacyPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/terms"
                element={
                  <AuthRoute>
                    <TermsPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/cookies"
                element={
                  <AuthRoute>
                    <CookiesPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/objection"
                element={
                  <AuthRoute>
                    <ObjectionsPage />
                  </AuthRoute>
                }
              />
              <Route
                path="/pages/developerRequest"
                element={
                  <AuthRoute>
                    <DeveloperRequestPage />
                  </AuthRoute>
                }
              />

              {/* socials */}
              <Route
                path="/socialLinks"
                element={
                  <AuthRoute>
                    <SocialLinks />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialLinks/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialLink />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialLinks/:id"
                element={
                  <AuthRoute>
                    <EditSocialLink />
                  </AuthRoute>
                }
              />
              {/* seo */}
              <Route
                path="/seo"
                element={
                  <AuthRoute>
                    <MetaSeo />
                  </AuthRoute>
                }
              />

              <Route
                path="/seo/add"
                element={
                  <AuthRoute>
                    <AddMetaSeo />
                  </AuthRoute>
                }
              />

              <Route
                path="/seo/edit/:slug"
                element={
                  <AuthRoute>
                    <EditMetaSeo />
                  </AuthRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
